import BaseModel from "./base/baseModel";
import ControleReclamacaoTipo from "./enum/controleReclamacaoTipo";
import ProdutoLoteModel from "./produtoLoteModel";

export default class ControleReclamacaoModel extends BaseModel {
    id?: number = null;
    clienteId?: number = null;
    fornecedorId?: number = null;
    vendaId?: number = null;
    vendaCodigo?: number = null;
    responsavel?: string = null;
    reclamacao: string = null;
    acao?: string = null;
    clienteNome?: string = null;
    clienteOuFornecedorNome?: string = null;
    atendente?: string = null;
    status: string = null;
    dataReclamacao: Date = null;
    statusDescricao?: string = null;
    setorDescricao?: string = null;
    categoriaControleReclamacaoId: number = null;
    categoriaControleReclamacaoDescricao?: string = null;
    tipo: ControleReclamacaoTipo = ControleReclamacaoTipo.Venda;
    produtoLoteId?: number = null;
    produtoLoteDescricao?: string = null;
    produtoLote?: ProdutoLoteModel = null;
    quantidade?: number = null;
    produtoId?: number = null;
    justificativaControleReclamacaoId: number = null;
    justificativaControleReclamacaoDescricao?: string = null;
    tipoPessoa? = 1;
}
